export default {
    temp: [],
    page: 0,
    noMoreItems: false,
    nothingFound: false,
    items: [],
    loading: null,
    status: 0,
    channel: null,

    getRoute(page) {
        return '/moderator/' + page + '/reports';
    },

    getParams() {
        let data = {};

        data.page = this.page;

        if (this.status !== null) {
            data.status = this.status;
        }

        if (this.channel !== null) {
            data.channel = this.channel;
        }

        return data;

    },

    getData(type = 'submissions') {
        return new Promise((resolve, reject) => {
            this.page++;
            this.loading = true;

            axios.get(this.getRoute(type), {
                params: this.getParams()
            }).then((response) => {

                this.items = [
                    ...this.items,
                    ...response.data.data
                ];

                if (!this.items.length && !response.data.data.length) this.nothingFound = true;

                if (response.data.links.next === null) this.noMoreItems = true;

                this.loading = false;

                resolve(response);
            }).catch((error) => {
                this.loading = false;

                reject(error);
            });
        });
    },

    clearData() {
        this.items = [];
        this.loading = true;
        this.nothingFound = false;
        this.noMoreItems = false;
        this.page = 0;
    },

    clear() {
        this.clearData();
        this.subRoute = '';
        this.status = 0;
        this.channel = null;
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/moderator.js